import React from "react";
import moment, { type Moment } from "moment";
import Button from "../../Buttons/Button";

type Props = {
    day: number;
    month: Moment;
    range: boolean;
    start: Moment | null;
    end: Moment | null;
    onClick: (value: Moment) => void;
    row: number;
    column: number;
    hover: Moment | null;
    onHoverChange: (hover: null | Moment) => void;
};

type State = {
    date: Moment;
    today: boolean;
    weekend: boolean;
};

export default class DatePickerDay extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        const date = props.month.clone().date(props.day);

        this.state = {
            today  : moment().isSame(date, "day"),
            weekend: date.day() % 6 === 0,
            date,
        };
    }

    public handleClick = (): void => {
        this.props.onClick(this.state.date);
    };

    public handleMouseEnter = (): void => {
        this.props.onHoverChange(this.state.date);
    };

    public handleMouseLeave = (): void => {
        this.props.onHoverChange(null);
    };

    public render(): React.ReactNode {
        const classes = [ "calendar-date-picker-month-day" ];

        if(this.state.weekend) {
            classes.push("weekend");
        }

        if(this.state.today) {
            classes.push("today");
        }

        let selected = false;

        if(moment.isMoment(this.props.start)) {
            if(this.props.start.isSame(this.state.date, "day")) {
                selected = true;
            }
        }

        if(!selected && moment.isMoment(this.props.end)) {
            if(this.props.end.isSame(this.state.date, "day")) {
                selected = true;
            }
        }

        if(selected) {
            classes.push("selected");
        }

        return (
            <Button
                type="button"
                classes={classes}
                onClick={this.handleClick}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                style={{
                    gridRow   : `${this.props.row} / span 1`,
                    gridColumn: `${this.props.column} / span 1`,
                }}
            >
                <div className="day-content">{this.state.date.date()}</div>
            </Button>
        );
    }
}
